import api from '~/api';
import axios from 'axios';

export type getListType = {
  eventId ? : string,
  beginDay? : string,
  endDay? : string,
  searchType? : string,
  searchCn? : string,
  sortType? : string,
  page? : number,
  itemsPerPage? : number,
  przwinBbscttAt?: boolean,
}

export type getType = {
  eventId : string,
}

//게시 이벤트 목록 조회 (PRG-COM-EVV-02)
export default (data: getListType) =>
  api({
    url: `${process.env.REACT_APP_DOMAIN_COMMON_BNET}/common/api/evboard-view`,
    method:'get',
    params:data,
  })

//이벤트 조회 (PRG-COM-EVF-03)
export const fetchEventGetDetail = (id: string) =>
  api({
    url: `${process.env.REACT_APP_DOMAIN_COMMON_BNET}/common/api/evboard-view/${id}`,
    method:'get',
  })

//첨부파일 목록 조회(PRG-COM-EVF-01)
export const fetchGetAttachList = (id: string) =>
  api({
      url: `${process.env.REACT_APP_DOMAIN_COMMON_BNET}/common/api/evboards/${id}/attachments`,
      method:'get',
  })

// 파일다운로드(전체)
export const fetchAllDownloadFile = (id: string) => {
  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_DOMAIN_COMMON_BNET}/common/api/evboards/${id}/attachmentsAll`,
  });
};

//이전글 다음글 eventId가져오기
export const fetchEventPreNext = (data: getListType) =>
  api({
    url: `${process.env.REACT_APP_DOMAIN_COMMON_BNET}/common/api/evboard-view/${data.eventId}/previous-next`,
    method:'get',
    params:data
  })